import Macy from 'macy';
import debounce from 'lodash.debounce';

export default class Masonry {
  init() {
    this.blocks = Array.from(document.querySelectorAll('.masonry'));
    this.masonryBlocks = [];

    if (!this.blocks) {
      return;
    }

    this.blocks.forEach((block) => {
      const masonryBlock = new Macy({
        container: block,
        trueOrder: true,
        mobileFirst: true,
        columns: 1,
        margin: {
          x: 20,
          y: 20,
        },
        breakAt: {
          768: {
            margin: {
              x: 20,
              y: 20,
            },
            columns: 2,
          },
        },
      });

      this.masonryBlocks.push(masonryBlock);
    });

    window.addEventListener(
      'resize',
      debounce(this.recalculateAllMasonryBlocks.bind(this), 300),
      window.supportPassive
    );

    this.recalculateAllMasonryBlocks();
  }

  recalculateAllMasonryBlocks() {
    this.masonryBlocks.forEach((masonryBlock) => {
      masonryBlock.recalculate();
    });
  }
}
